<template>
  <AppLayout>
    <div class="task-page">
      <div class="container">
        <!-- 主内容卡片 -->
        <div class="detail-card">
          <h1 class="title">
            {{ task.title }}
          </h1>

          <div class="pill-row">
            <span class="pill pill--primary">{{ task.badge }}</span>
            <span class="pill pill--ghost">{{ task.type }}</span>
          </div>

          <div class="section">
            <div class="section-title">项目介绍</div>
            <div class="section-desc">
              {{ task.desc }}
            </div>
          </div>

          <div class="section">
            <div class="section-title">技能要求</div>
            <div class="tags">
              <span v-for="t in task.tags" :key="t" class="tag">{{ t }}</span>
            </div>
          </div>

          <div class="meta-row">
            <div class="meta-item">
              <img class="meta-icon" src="../assets/项目预算 1@2x.png" alt="" />
              <div class="meta-text">
                <div class="meta-main">¥ {{ task.budget }}</div>
                <div class="meta-sub">项目预算</div>
              </div>
            </div>

            <div class="meta-item">
              <img class="meta-icon" src="../assets/截止时间 1@2x.png" alt="" />
              <div class="meta-text">
                <div class="meta-main">{{ task.deadline }}</div>
                <div class="meta-sub">截止时间</div>
              </div>
            </div>

            <div class="meta-item">
              <img class="meta-icon" src="../assets/定位 1@2x.png" alt="" />
              <div class="meta-text">
                <div class="meta-main">{{ task.mode }}</div>
                <div class="meta-sub">位置</div>
              </div>
            </div>
          </div>

          <button class="cta" type="button" @click="openQuote">
            立即报价
            <img class="cta-arrow" src="../assets/next.png" alt="" />
          </button>
        </div>
      </div>

    <!-- 报价弹窗 -->
    <el-dialog v-model="quoteOpen" width="640px" align-center :teleported="false" :show-close="false"
        :close-on-click-modal="true" :close-on-press-escape="true" class="quote-dialog">
        <div class="quote-body">
          <div class="quote-title">立即报价</div>

          <el-form ref="quoteFormRef" class="quote-form" :model="quoteForm" :rules="quoteRules" label-position="top"
            status-icon :hide-required-asterisk="false" @submit.prevent>
            <el-form-item label="金额" prop="price" required>
              <el-input v-model.trim="quoteForm.price" placeholder="请输入" />
            </el-form-item>

            <el-form-item label="预计完成时间" prop="eta" required>
              <el-date-picker v-model="quoteForm.eta" type="date" placeholder="请选择" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%;height:52px" />
            </el-form-item>

            <el-button class="quote-submit" type="success" :loading="submitting" @click="submitQuote">
              提交
            </el-button>
          </el-form>
        </div>
      </el-dialog>

      <!-- 报价成功弹窗 -->
      <el-dialog v-model="successOpen" width="420px" align-center :teleported="false" modal :lock-scroll="true"
        :show-close="false" :close-on-click-modal="true" :close-on-press-escape="true" class="success-dialog">
        <div class="success-body">
          <img class="success-icon" src="../assets/Frame 9800.png" alt="" />
          <div class="success-title">报价成功</div>
          <div class="success-desc">报价成功，等待甲方回复</div>

          <div class="success-actions">
            <el-button type="success" class="success-cta" @click="continueBrowse">继续浏览</el-button>
            <el-button type="success" link @click="goHome">返回首页</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </AppLayout>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const router = useRouter()

/** 示例数据：后续你可以换成接口/路由参数请求 */
const task = reactive({
  id: 1,
  title: '项目名称项目名称项目名称项目名称项目名称项目名称项目名称项目名称',
  badge: '商品',
  type: '商用',
  budget: 1000,
  deadline: '2026-01-01',
  mode: '线上',
  desc:
    '项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍…项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍项目介绍',
  tags: ['技能1', '技能2', '技能2', '技能2', '技能2'],
})

/* ===== 报价弹窗逻辑（同 TaskList 版本） ===== */
const quoteOpen = ref(false)
const successOpen = ref(false)
const submitting = ref(false)

const quoteFormRef = ref(null)
const quoteForm = reactive({
  price: '',
  eta: '', // YYYY-MM-DD
})

function validateMoney(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请输入金额'))
  if (!/^\d+(\.\d{1,2})?$/.test(val)) return cb(new Error('金额格式不正确（最多两位小数）'))
  const n = Number(val)
  if (!Number.isFinite(n) || n <= 0) return cb(new Error('金额必须大于 0'))
  cb()
}

function validateEta(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请选择预计完成时间'))
  cb()
}

const quoteRules = reactive({
  price: [
    { required: true, message: '请输入金额', trigger: 'blur' },
    { validator: validateMoney, trigger: ['blur', 'change'] },
  ],
  eta: [
    { required: true, message: '请选择预计完成时间', trigger: 'change' },
    { validator: validateEta, trigger: 'change' },
  ],
})

function openQuote() {
  quoteForm.price = ''
  quoteForm.eta = ''
  quoteOpen.value = true
}

async function submitQuote() {
  if (!quoteFormRef.value) return
  try {
    await quoteFormRef.value.validate()
    submitting.value = true
    await new Promise((r) => setTimeout(r, 600))
    quoteOpen.value = false
    successOpen.value = true
  } catch {
    // 校验不通过：自动显示错误提示
  } finally {
    submitting.value = false
  }
}

function continueBrowse() {
  successOpen.value = false
}

function goHome() {
  successOpen.value = false
  router.push('/home')
}
</script>

<style lang="scss" scoped>
/* 页面背景与左右留白（对齐 header） */
.task-page {
  min-height: calc(100vh - 64px);
  padding: 28px 240px 64px;
  background: #ffffff;

  @media (max-width: 1400px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  @media (max-width: 960px) {
    padding: 18px 16px 48px;
  }
}

.container {
  width: 100%;
}

/* 详情卡片：参考你截图的“左上内容块” */
.detail-card {
  max-width: 1180px;
  padding: 32px 0 0px;
}

.title {
  margin: 0 0 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
}

.pill-row {
  display: flex;
  gap: 10px;
  margin-bottom: 18px;
}

.pill {
  width: 55px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  user-select: none;
  margin-bottom: 54px;
}

.pill--primary {
  color: #4CAF50;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #4CAF50;
  display: flex;
  justify-content: center;
}

.pill--ghost {
  color: #A5A5A5;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #A5A5A5;
  display: flex;
  justify-content: center;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 8px;
}

.section-desc {
  font-weight: 400;
  font-size: 14px;
  color: #181818;
  line-height: 25px;
  max-width: 1200px;
  margin-bottom: 48px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  width: 96px;
  height: 32px;
  background: #F6F6F6;
  border-radius: 20px 20px 20px 20px;
  border: none;
  font-weight: 400;
  font-size: 12px;
  color: #676767;
  line-height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  margin: 48px 0 48px;
  max-width: 520px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.meta-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.meta-icon {
  width: 24px;
  height: 24px;
}

.meta-text {
  min-width: 0;
}

.meta-main {
  height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meta-sub {
  margin-top: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #A5A5A5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 立即报价按钮（看齐截图：绿色长按钮） */
.cta {
  width: 240px;
  height: 56px;
  background: #4CAF50;
  border-radius: 8px 8px 8px 8px;
  border: none;

  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  // gap: 8px;

  transition: 0.2s ease;
}

.cta:hover {
  filter: brightness(0.98);
}

.cta:active {
  transform: translateY(1px);
}

.cta-arrow {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

/* ===== 报价弹窗样式（修复校验遮挡） ===== */
:deep(.quote-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.quote-dialog .el-dialog__header) {
  display: none;
}

:deep(.quote-dialog .el-dialog__body) {
  padding: 0;
}

.quote-body {
  padding: 32px 63px;
}

.quote-title {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin: 0px 0 18px;
}

/* ✅ 强力版：只作用在当前弹窗的表单，确保错误提示不覆盖 */
:deep(.quote-dialog .quote-form) {
  :deep.el-input__wrapper{
    height: 52px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }

  .el-form-item__label {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    padding-bottom: 6px;
  }

  .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: static !important;
  }

  .el-form-item__error,
  .el-form-item__error--inline {
    position: static !important;
    display: block !important;
    width: 100%;

    margin-top: 6px;
    padding: 0;
    line-height: 1.2;
    white-space: normal;

    z-index: auto !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
  }
  

  .el-input__wrapper,
  .el-date-editor .el-input__wrapper {
    min-height: 48px;
    border-radius: 6px;
    box-sizing: border-box;
  }
}

:deep(.quote-submit.el-button) {

  height: 48px;
  background: #4CAF50;
  border-radius: 4px 4px 4px 4px;
  width: 100%;

  margin-top: 36px;

  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

/* 成功弹窗样式（保持不动） */
:deep(.success-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.success-dialog .el-dialog__header) {
  display: none;
}

:deep(.success-dialog .el-dialog__body) {
  padding: 32px 63px;
}

.success-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon {
  margin: 0px 0 28px;
  width: 100px;
  height: 100px;

  .ring {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: linear-gradient(180deg, #6fe36a 0%, #34b34a 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 22px rgba(46, 160, 67, 0.25);
  }

  .check {
    color: #fff;
    font-size: 44px;
    font-weight: 800;
    line-height: 1;
  }
}

.success-title {
  font-weight: 400;
  font-size: 20px;
  color: #2E323E;
  margin-bottom: 6px;
}

.success-desc {
  font-weight: 400;
  font-size: 16px;
  color: #9899A2;
  margin-bottom: 48px;
}

.success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
}

:deep(.success-cta.el-button) {
  width: 260px;
  height: 41px;
  background: linear-gradient(39deg, #4CAF50 0%, #91DF35 100%);
  box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
  border-radius: 200px 200px 200px 200px;
  // margin-bottom: 6px;
}
</style>